// Module
var code = "<div class=\"u-sizeFullWidth ui-grid-cell-contents\">\n    <span ng-class=\"{'c-entitlementBalance--negative': row.entity.usage.balanceUsed < 0}\" ng-bind=\"::row.entity.usage.balanceUsed | number:2\">\n    </span> \n    <span ng-bind=\"::row.entity.usage.initialBalanceUnit\"></span>\n</div>\n";
// Exports
module.exports = code;